import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useProfile } from "./get-profile";
import { createUserRequestRemovingAddress, updateUser } from "./utils";

import type { MutationConfig } from "@/lib/react-query";
import type { User } from "@/types/user";

type useRemoveAddressOptions = {
  mutationConfig?: MutationConfig<(index: number) => Promise<User>>;
};

export const useRemoveAddress = ({ mutationConfig }: useRemoveAddressOptions = {}) => {
  const queryClient = useQueryClient();
  const { data: user } = useProfile();
  const createRequest = createUserRequestRemovingAddress(user);

  const { onSuccess, ...restConfig } = mutationConfig || {};

  return useMutation({
    mutationFn: (index) => updateUser(createRequest(index)),
    onSuccess: (data, variables, onMutateResult, context) => {
      queryClient.setQueryData(["profile"], data);
      onSuccess?.(data, variables, onMutateResult, context);
    },
    ...restConfig,
  });
};
